import moment from 'moment';

/*
Changes moment.js's a/A format to insert periods
i.e.
am -> a.m.
pm -> p.m.
e.g.
> moment("2020-07-02T00:00:00+08:00").format("h:mm a")
> "12:00 a.m."
*/
moment.updateLocale('en', {
  meridiem(hour, minute, isLowerCase) {
    return hour < 12 ? 'a.m.' : 'p.m.';
  },
});

export const SW_DATE_FORMAT = 'D/MM/YYYY h:mm a';
